import axios from 'axios';
import {getLang} from './util';

export async function getI18NMessage(){
	let lang = getLang();
	let result;

	try{
		result = await axios({
			method: 'get',
			responseType: 'json',
			url: `/i18n/not-supported-ie/${lang}.json`
		});
		return result.data;

	}catch(err){
		console.error(`Get Json: ${lang} fail`);
		throw(err);
	}
}

